import { Component, Inject, Input } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

import { IdentificationCodeType, PartyIdentificationType } from '@nano/common/party-identification';

@Component({
  selector: 'app-payment-additional-info-identification',
  templateUrl: 'payment-additional-info-identification.component.html',
  styleUrls: ['./payment-additional-info-identification.component.less'],
  standalone: false
})
export class PaymentAdditionalInfoIdentificationComponent {
  @Input() identification: PartyIdentificationType;
  @Input() identificationType: string;
  @Input() identificationCodeType: string;
  @Input() identificationCode: string;
  @Input() identificationLegalEntityIdentifier: string;
  @Input() identificationBic: string;
  @Input() identificationDocument: string;
  @Input() id: string;
  @Input() identificationIssueCountry: string;
  @Input() identificationIssueDate: string;
  @Input() identificationExpiryDate: string;
  @Input() birthDate: string;
  @Input() countryOfBirth: string;
  @Input() provinceOfBirth: string;
  @Input() cityOfBirth: string;
  @Input() identificationName: string;
  @Input() identificationSurname: string;

  readonly PartyIdentificationType = PartyIdentificationType;
  readonly IdentificationCodeType = IdentificationCodeType;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

  get displayIdentificationType(): boolean {
    return (
      (this.identificationType && !!(this.identificationCodeType || this.identificationDocument)) ||
      !!(this.id && this.birthDate && this.countryOfBirth && this.provinceOfBirth && this.cityOfBirth)
    );
  }

  get displayIdentificationCodeTypeOnly(): boolean {
    return !!this.identification && !this.identificationType && !!this.identificationCodeType;
  }
}
